const handleSubcategories = () => {
  const subcategoryLinks = document.querySelectorAll(".subcategories li a");
  console.log(subcategoryLinks);

  for (let i = 0; i < subcategoryLinks.length; i++) {
    const link = subcategoryLinks[i];
    const img = link.querySelector("img");
    if (img) {
      img.setAttribute(
        "data-src",
        img.getAttribute("data-src").replace("/thumb/", "/orig/")
      );
      img.src = img.src.replace("/thumb/", "/orig/");
    }
    const text = link.querySelector(".text");
    if (text?.textContent.includes("FAV")) {
      link.classList.add("fav");
      text.innerHTML = text.innerHTML.replace("FAV", "");
    }
  }
  if (subcategoryLinks.length > 6) {
    const showAllSubcategories = document.createElement("button");
    showAllSubcategories.classList.add("btn", "btn-tertiary");
    showAllSubcategories.textContent = "Zobrazit další";
    showAllSubcategories.setAttribute("data-text-alt", "Skrýt");
    const subcategoriesList = document.querySelector(".subcategories");
    subcategoriesList.appendChild(showAllSubcategories);
    showAllSubcategories.addEventListener("click", () => {
      subcategoriesList.classList.toggle("show-all");
      const help = showAllSubcategories.textContent;
      showAllSubcategories.textContent =
        showAllSubcategories.getAttribute("data-text-alt");
      showAllSubcategories.setAttribute("data-text-alt", help);
    });
  }
};

const handlePriceSlider = () => {
  const sliderFrom = document.querySelector(".slider-wrapper .from");
  const sliderTo = document.querySelector(".slider-wrapper .to");
  const sliderContent = document.querySelector(
    ".slider-wrapper .slider-content"
  );
  if (!sliderFrom || !sliderTo || !sliderContent) return;
  sliderContent.parentElement.insertBefore(sliderFrom, sliderContent);
  sliderContent.parentElement.insertBefore(
    sliderTo,
    sliderContent.nextElementSibling
  );
};

const handleFilters = () => {
  const filterH4s = document.querySelectorAll("#category-filter-hover h4");
  for (let i = 0; i < filterH4s.length; i++) {
    const h4 = filterH4s[i];
    h4.addEventListener("click", () => {
      h4.classList.toggle("active");
    });
  }
};

const renameStockLabel = () => {
  const stockLabel = document.querySelector('.filter-label[for="stock"]');
  if (stockLabel) stockLabel.innerText = "Skladem";
};

const handleCategoryBanners = () => {
  const categoryBanners = document.querySelectorAll(".banner-category");
  const firstProductBlock = document.querySelector("#products");
  const secondProductBlock = document.querySelector(
    ".products-block:not(#products)"
  );
  if (secondProductBlock) {
    const secondBlockProducts = secondProductBlock.querySelectorAll(".product");
    for (let i = 0; i < secondBlockProducts.length; i++) {
      const product = secondBlockProducts[i];
      if (firstProductBlock) firstProductBlock.appendChild(product);
    }
    secondProductBlock.remove();
  }
  for (let i = 0; i < categoryBanners.length; i++) {
    const categoryBanner = categoryBanners[i];
    if (categoryBanner && firstProductBlock) {
      categoryBanner.classList.add("product");
      let whereToAppend = null;
      switch (i) {
        case 0:
          whereToAppend = firstProductBlock.querySelector(
            ".product:nth-child(6)"
          );
          categoryBanner.classList.add("banner-category-1");
          break;
        case 1:
          whereToAppend = firstProductBlock.querySelector(
            ".product:nth-child(10)"
          );
          categoryBanner.classList.add("banner-category-2");
          break;
        case 2:
          whereToAppend = firstProductBlock.querySelector(
            ".product:nth-child(14)"
          );
          categoryBanner.classList.add("banner-category-3");
          break;
      }
      if (whereToAppend) {
        whereToAppend.after(categoryBanner);
      } else {
        firstProductBlock.appendChild(categoryBanner);
      }
    }
  }
};

const fetchLoyaltyBanner = async () => {
  const loyaltyCookie = window.sessionStorage.getItem("loyaltyBanner");
  let el = null;
  if (!loyaltyCookie) {
    try {
      const response = await fetch("/");
      const html = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, "text/html");
      if (!doc) return;
      const loyaltyBanner = doc.querySelector(".loyalty-program");
      if (!loyaltyBanner) return;
      window.sessionStorage.setItem("loyaltyBanner", loyaltyBanner.innerHTML);
      el = loyaltyBanner;
    } catch (e) {
      console.error("Error fetching loyalty banner:", e);
    }
  } else {
    const loyaltyBanner = document.createElement("div");
    loyaltyBanner.classList.add("loyalty-program");
    loyaltyBanner.innerHTML = loyaltyCookie;
    el = loyaltyBanner;
  }
  const contentWrapper = document.querySelector("#content-wrapper");
  if (contentWrapper && el) {
    contentWrapper.parentElement.insertBefore(
      el,
      contentWrapper.nextElementSibling
    );
  }
};

const handleCategoryBG = () => {
  const categoryBG = document.querySelectorAll(
    ".category__secondDescription > p img"
  );
  if (categoryBG.length) {
    const categoryTopWrapper = document.createElement("div");
    categoryTopWrapper.classList.add("category-top-wrapper");
    const categoryTopWrapperContainer = document.createElement("div");
    categoryTopWrapperContainer.classList.add("container");
    categoryTopWrapper.appendChild(categoryTopWrapperContainer);
    const categoryTitle = document.querySelector(".category-title");
    const categoryPerex = document.querySelector(".category-perex");
    if (categoryTitle) categoryTopWrapperContainer.appendChild(categoryTitle);
    if (categoryPerex) categoryTopWrapperContainer.appendChild(categoryPerex);
    const contentWrapper = document.querySelector("#content-wrapper");
    contentWrapper.parentElement.insertBefore(
      categoryTopWrapper,
      contentWrapper
    );
    let desktopImg;
    let mobileImg;
    const imagesLoading = [];
    categoryBG.forEach((img) => {
      imagesLoading.push(
        new Promise((resolve) => {
          if (img.complete) {
            if (img.naturalWidth > 1440) {
              desktopImg = img;
            } else if (img.naturalWidth <= 1440) {
              mobileImg = img;
            }
            img.closest("p").remove();
            resolve();
          } else {
            img.addEventListener("load", () => {
              if (img.naturalWidth > 1440) {
                desktopImg = img;
              } else if (img.naturalWidth <= 1440) {
                mobileImg = img;
              }
              img.closest("p").remove();
              resolve();
            });
          }
        })
      );
    });
    Promise.all(imagesLoading)
      .then(() => {
        // setBackground(desktopImg, mobileImg)
        if (window.innerWidth >= 768) {
          categoryTopWrapper.style.backgroundImage = `url(${desktopImg?.src})`;
        } else {
          if (mobileImg) {
            categoryTopWrapper.style.backgroundImage = `url(${mobileImg?.src})`;
            const mobileCategoryImage = document.createElement("img");
            mobileCategoryImage.src = mobileImg?.src;
            mobileCategoryImage.alt = "";
            mobileCategoryImage.width = mobileImg?.naturalWidth;
            mobileCategoryImage.height = mobileImg?.naturalHeight;
            mobileCategoryImage.classList.add("mobile-category-image");
            categoryTopWrapper.prepend(mobileCategoryImage);
          }
        }
      })
      .catch((e) => {
        console.log(e);
      });
  }
};

const handleSecondDescriptionImages = () => {
  const categoryTop = document.querySelector(".category-top-wrapper");
  const secondDescriptionImages = document.querySelectorAll(
    ".category__secondDescription > p:has(img)"
  );
  if (categoryTop && secondDescriptionImages) {
    for (let i = 0; i < secondDescriptionImages.length; i++) {
      secondDescriptionImages[i].style.display = "none";
    }
  }
};

const handleReadMoreBtn = () => {
  const secondDesc = document.querySelector(".category__secondDescription");
  if (!secondDesc) return;
  const perex = document.querySelector(".category-perex");
  if (!perex) return;
  if (perex.querySelector(".category-read-more")) return;

  const btn = document.createElement("button");
  btn.type = "button";
  btn.className = "category-read-more";
  btn.innerHTML = `Číst více <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6 9l6 6 6-6" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>`;
  btn.addEventListener("click", () => {
    secondDesc.scrollIntoView({ behavior: "smooth", block: "start" });
  });
  perex.appendChild(btn);
};

const handleSecondDescriptionPosition = () => {
  const sidebarInner = document.querySelector("#content");
  if (!sidebarInner) return;
  const allDescs = document.querySelectorAll(".category__secondDescription");
  if (!allDescs.length) return;
  allDescs.forEach((el, i) => {
    if (i > 0) el.remove();
  });
  sidebarInner.after(allDescs[0]);
};

const handleVisitedProducts = () => {
  const moveVisited = () => {
    const anchor =
      document.querySelector(".category__secondDescription") ||
      document.querySelector("#content");
    if (!anchor) return;
    const allVisited = document.querySelectorAll(".dkLabVisitedProductsNew");
    if (!allVisited.length) return;
    allVisited.forEach((el, i) => {
      if (i > 0) {
        el.remove();
        return;
      }
      if (anchor.nextElementSibling === el) return;
      anchor.after(el);
    });
  };

  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      for (const node of mutation.addedNodes) {
        if (node.nodeType !== 1) continue;
        if (
          node.classList?.contains("dkLabVisitedProductsNew") ||
          node.querySelector?.(".dkLabVisitedProductsNew")
        ) {
          moveVisited();
          return;
        }
      }
    }
  });
  observer.observe(document.body, { childList: true, subtree: true });

  moveVisited();
};

const initMobileCategoryControls = () => {
  if (window.innerWidth > 767) return;
  if (document.querySelector(".mobile-cat-controls")) return;

  const categoryHeader = document.querySelector("#category-header");
  const listSortingControls = document.querySelector(".listSorting__controls");

  if (!categoryHeader) return;

  // Two action buttons
  const mobileControls = document.createElement("div");
  mobileControls.className = "mobile-cat-controls";

  const sortBtn = document.createElement("button");
  sortBtn.type = "button";
  sortBtn.className = "mobile-cat-btn mobile-cat-btn--sort";
  sortBtn.innerHTML = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><line x1="3" y1="6" x2="21" y2="6" stroke="currentColor" stroke-width="2" stroke-linecap="round"/><line x1="6" y1="12" x2="18" y2="12" stroke="currentColor" stroke-width="2" stroke-linecap="round"/><line x1="9" y1="18" x2="15" y2="18" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg><span>Řazení</span>`;

  const filterBtn = document.createElement("button");
  filterBtn.type = "button";
  filterBtn.className = "mobile-cat-btn mobile-cat-btn--filter";
  filterBtn.innerHTML = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M22 3H2l8 9.46V19l4 2V12.46L22 3z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg><span>Filtrace</span>`;

  mobileControls.appendChild(sortBtn);
  mobileControls.appendChild(filterBtn);
  categoryHeader.appendChild(mobileControls);

  // Overlay backdrop — reuse if already exists
  let overlay = document.querySelector(".mobile-cat-overlay");
  if (!overlay) {
    overlay = document.createElement("div");
    overlay.className = "mobile-cat-overlay";
    document.body.appendChild(overlay);
    overlay.addEventListener("click", closeAll);
  }

  function closeAll() {
    document.querySelectorAll(".mobile-cat-sheet").forEach((s) => s.classList.remove("is-open"));
    document.querySelectorAll(".mobile-cat-overlay").forEach((o) => o.classList.remove("is-visible"));
    document.body.classList.remove("mobile-sheet-open");
  }

  const makeSheetTop = (title) => {
    const top = document.createElement("div");
    top.className = "mobile-cat-sheet__top";
    const span = document.createElement("span");
    span.textContent = title;
    const closeBtn = document.createElement("button");
    closeBtn.type = "button";
    closeBtn.className = "mobile-cat-sheet__close";
    closeBtn.setAttribute("aria-label", "Zavřít");
    closeBtn.innerHTML = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M18 6L6 18M6 6l12 12" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>`;
    closeBtn.addEventListener("click", closeAll);
    top.appendChild(span);
    top.appendChild(closeBtn);
    return top;
  };

  // Sort bottom sheet
  if (
    listSortingControls &&
    !listSortingControls.classList.contains("mobile-cat-sheet")
  ) {
    listSortingControls.classList.add("mobile-cat-sheet");
    listSortingControls.insertBefore(
      makeSheetTop("Řazení"),
      listSortingControls.firstChild
    );

    listSortingControls.addEventListener("click", (e) => {
      if (e.target.closest(".listSorting__control")) closeAll();
    });

    sortBtn.addEventListener("click", () => {
      listSortingControls.classList.add("is-open");
      overlay.classList.add("is-visible");
      document.body.classList.add("mobile-sheet-open");
    });
  }

  const initFilterSheet = () => {
    const fw = document.querySelector("#filters-wrapper");
    if (!fw || fw.classList.contains("mobile-cat-sheet")) return;
    fw.classList.add("mobile-cat-sheet");
    fw.insertBefore(makeSheetTop("Filtrace"), fw.firstChild);

    // Filters apply instantly, so this button just closes the sheet.
    const applyBtn = document.createElement("button");
    applyBtn.type = "button";
    applyBtn.className = "mobile-cat-sheet__apply";
    applyBtn.textContent = "Použít filtry";
    applyBtn.addEventListener("click", closeAll);
    fw.appendChild(applyBtn);

    if (document.body.classList.contains("mobile-sheet-open")) {
      fw.classList.add("is-open");
    }
  };

  // Filter bottom sheet
  initFilterSheet();

  filterBtn.addEventListener("click", () => {
    const fw = document.querySelector("#filters-wrapper");
    if (fw) {
      fw.classList.add("is-open");
      overlay.classList.add("is-visible");
      document.body.classList.add("mobile-sheet-open");
    }
  });

  document.addEventListener("ShoptetDOMContentLoaded", initFilterSheet);
  document.addEventListener("ShoptetPageFilterValueChange", initFilterSheet);
  document.addEventListener("ShoptetPageFiltersCleared", closeAll);
};

export {
  handleSubcategories,
  handlePriceSlider,
  handleFilters,
  handleCategoryBanners,
  fetchLoyaltyBanner,
  handleCategoryBG,
  renameStockLabel,
  handleSecondDescriptionImages,
  handleSecondDescriptionPosition,
  initMobileCategoryControls,
  handleVisitedProducts,
  handleReadMoreBtn,
};
